import { appSettingsHubTr } from './settingsHub.tr.js';
import { appOmgevingTr } from './omgevingApp.tr.js';
import { appRecurrenceTr } from './recurrenceApp.tr.js';
import { appDomeinTr } from './domeinApp.tr.js';
import { appMemorizeTr } from './memorizeApp.tr.js';
import { appSamenTr } from './samenApp.tr.js';
import { appCareTr } from './careApp.tr.js';
import { appCultureTr } from './cultureApp.tr.js';
import { appActivitiesTr, appChecklistTr } from './golf2App.tr.js';
import { appGrowthTr, appSchoolTr } from './groeiSchoolApp.tr.js';
import { appBoardConfigTr } from './boardConfigApp.tr.js';
import { appAgendaViewsTr, appHomeTr, appWeatherDetailTr } from './homeApp.tr.js';
import { appDevicesG4Tr, appEditorG4Tr, appPrivacyRightsTr } from './golf4App.tr.js';
import { appFeedsTr, appPlacesTr, appTravelTr } from './kaartApp.tr.js';
import { appLanguagesTr } from './languagesApp.tr.js';
import { appReadAloudTr } from './readAloudApp.tr.js';
import { appModulesTr } from './modulesApp.tr.js';
import { appHouseholdsTr } from './householdsApp.tr.js';
import { appProfileTr } from './profileApp.tr.js';
import { appPushTr } from './pushApp.tr.js';
import { appRemindersTr } from './remindersApp.tr.js';
import { appTodoTr } from './todoApp.tr.js';
import { appMissedTr } from './missedApp.tr.js';
import { appBillingTr } from './billingApp.tr.js';
import { appRidesTr } from './ridesApp.tr.js';
import { appTimePickerTr } from './timePicker.tr.js';
import { appVirtualDeviceTr } from './virtualDevice.tr.js';
import { appBoardViewTr } from './boardViewApp.tr.js';
import { appDailyTr } from './dailyApp.tr.js';
import { appThemesTr } from './themesApp.tr.js';
import { appGolf6Tr } from './golf6App.tr.js';
import { appWerklijstTr } from './werklijstApp.tr.js';
import { appChildConsentTr, appPrivacyStatementTr } from './golf5App.tr.js';
// Turks (tr-TR): teksten van de ouder-webapp (zelfde vorm als app.nl.ts). Toon: warme sen-vorm
// voor de ouder, ook bij "jullie gezin/plaats/moskee" (ailen, camin; golf 3 r2: geen siz en sen
// door elkaar). Meervoud alleen met een groep als onderwerp (ailece, birlikte, sen ve ailen,
// siz ebeveynler) en op de tablet voor het hele gezin. Na een {naam} geen achtervoegsel
// (klinkerharmonie is onbekend): liever "için", een dubbele punt of de naam als onderwerp.
export const appTr = {
    // Golf 7 (0048): Soera's leren (memorizeApp.tr.ts).
    // Nieuwe adressen (amumin.app, board.amumin.app): bedrijfsgegevens en meldingen (domeinApp.tr.ts).
    domein: appDomeinTr,
    memorize: appMemorizeTr,
    // Golf 8 (0049): Samen wonen (samenApp.tr.ts).
    samen: appSamenTr,
    // Golf 8 (0050): dagelijkse check-in en familiekring (careApp.tr.ts).
    care: appCareTr,
    reminders: appRemindersTr,
    // 0058: to-do's zonder datum of tijd (todoApp.tr.ts).
    todo: appTodoTr,
    missed: appMissedTr,
    // 0065: aanmelden, abonnement en de banner na de proefmaand (billingApp.tr.ts).
    billing: appBillingTr,
    profile: appProfileTr,
    culture: appCultureTr,
    timePicker: appTimePickerTr,
    ridesPerDay: appRidesTr,
    modules: appModulesTr,
    // Golf 6b (0043): soorten huishouden en het beurtrooster (householdsApp.tr.ts).
    households: appHouseholdsTr,
    checklist: appChecklistTr,
    activities: appActivitiesTr,
    languages: appLanguagesTr,
    readAloud: appReadAloudTr,
    // Golf 3-integratie: groei en school (0032), kaart en agenda (0034), werklijst, virtuele iPad (0028).
    growth: appGrowthTr,
    school: appSchoolTr,
    places: appPlacesTr,
    travel: appTravelTr,
    feeds: appFeedsTr,
    werklijst: appWerklijstTr,
    virtualDevice: appVirtualDeviceTr,
    // Menu Board: het echte bord live bekijken (boardViewApp.tr.ts).
    boardView: appBoardViewTr,
    // WP4: Sterren in Taken, Ritten in Agenda, Prikbord, Kinderen, Recepten en Weekmenu (dailyApp.tr.ts).
    daily: appDailyTr,
    themes: appThemesTr,
    // Golf 6b: Vandaag als widgets, agendaweergaven en het weerdetail (homeApp.tr.ts).
    home: appHomeTr,
    // Scherm inrichten: widgets van het bord per tablet (boardConfigApp.tr.ts).
    boardConfig: appBoardConfigTr,
    agendaViews: appAgendaViewsTr,
    weatherDetail: appWeatherDetailTr,
    golf6: appGolf6Tr,
    // 0036: Jouw gegevens (golf 4).
    privacyRights: appPrivacyRightsTr,
    // Instellingen als overzicht (settingsHub.tr.ts).
    settingsHub: appSettingsHubTr,
    // Omgevingen, eigen thema, agendaverbindingen (omgevingApp.tr.ts).
    omgeving: appOmgevingTr,
    // Herhaling in gewone taal (recurrenceApp.tr.ts; packages/domain summaryLang.ts).
    recurrenceText: appRecurrenceTr,
    // Golf 5 (0044): toestemming voor een kindlogin of foto; de privacyverklaring (golf5App.tr.ts).
    childConsent: appChildConsentTr,
    privacyStatement: appPrivacyStatementTr,
    // 0038: meldingen op je telefoon (pushApp.tr.ts).
    push: appPushTr,
    nav: {
        // 0060: module Notities.
        notes: 'Notlar',
        // 0064: module Fotolijst.
        photos: 'Fotoğraf çerçevesi',
        kompas: 'Sağlıklı kilo',
        // 0069: module Geldzaken (privé).
        money: 'Para işleri',
        // Oprichter 6 okt: eigen to-do's in Mijn omgeving.
        myTodos: 'Yapılacaklarım',
        today: 'Bugün',
        board: 'Pano',
        agenda: 'Takvim',
        tasks: 'Görevler',
        rewards: 'Ödüller',
        approvals: 'Onaylar',
        members: 'Aile',
        devices: 'Tabletler',
        settings: 'Ayarlar',
        security: 'Güvenlik',
        household: 'Kurulum',
        rides: 'Ulaşım',
        more: 'Daha fazla',
        // WP2 (compact-plan): de vijf vaste plekken en de samengevoegde pagina's onder Meer.
        pinboard: 'Not panosu',
        children: 'Çocuklar',
        together: 'Birlikte',
        boardHub: 'Pano',
        boardView: 'Görünüm',
        stars: 'Yıldızlar',
        membersTab: 'Üyeler',
        circle: 'Çevre',
        forYou: 'Senin için',
        forYouWaiting: 'Onay bekleyen: {n}',
        menu: 'Menü',
        logout: 'Çıkış yap',
        main: 'Ana menü',
        skip: 'İçeriğe geç',
        growth: 'Büyüme',
        school: 'Okul',
        admin: 'Yönetim',
        werklijst: 'İş listesi',
    },
    common: {
        save: 'Kaydet',
        cancel: 'Vazgeç',
        delete: 'Sil',
        edit: 'Düzenle',
        add: 'Ekle',
        close: 'Kapat',
        back: 'Geri',
        next: 'İleri',
        later: 'Sonra yap',
        undo: 'Geri al',
        retry: 'Tekrar dene',
        info: 'Açıklama',
        moreCount: '+{n} daha',
        loading: 'Yükleniyor…',
        optional: 'isteğe bağlı',
        yes: 'Evet',
        no: 'Hayır',
        none: 'Yok',
        everyone: 'Herkes',
        minutes: { one: '{count} dakika', other: '{count} dakika' },
        minutesShort: '{count} dk',
        hoursMinutes: '{h} sa {m} dk',
        hours: { one: '{count} saat', other: '{count} saat' },
        points: { one: '{count} puan', other: '{count} puan' },
        by: '{name} tarafından',
        unknown: 'Bilinmiyor',
        errorLoad: 'Bu şu an yüklenemedi. Tekrar dene.',
        savedOk: 'Kaydedildi',
    },
    offline: 'Sunucuya bağlantı yok. Kendiliğinden tekrar deniyoruz.',
    // ---- W1 Bugün --------------------------------------------------------------------------------
    today: {
        goodMorning: 'Günaydın',
        goodAfternoon: 'İyi günler',
        goodEvening: 'İyi akşamlar',
        goodNight: 'İyi geceler',
        week: '{week}. hafta',
        next: 'Sırada',
        now: 'Şu an',
        startsIn: '{time} sonra',
        endsIn: '{time} kaldı',
        nothingNext: 'Bugün başka plan yok',
        nothingNextBody: 'Birbirinize vakit ayırın.',
        agenda: 'Bugünün takvimi',
        addEvent: 'Etkinlik',
        addEventLong: 'Etkinlik ekle',
        tasks: 'Bugünün görevleri',
        tasksAll: 'Tüm görevler',
        noTasks: 'Bugün görev yok',
        approvals: 'Onaylar',
        approvalsWaiting: {
            one: '{count} şey seni bekliyor',
            other: '{count} şey seni bekliyor',
        },
        approvalsView: 'Göz at',
        ridesOpen: {
            one: 'Sürücüsü olmayan {count} yolculuk',
            other: 'Sürücüsü olmayan {count} yolculuk',
        },
        ridesAll: 'Tüm yolculuklar',
        tomorrow: 'Yarın',
        tomorrowNothing: 'Yarın için henüz bir şey yok.',
        toAgenda: 'Takvime git',
        goalsTitle: 'Birikim',
    },
    // ---- W2 Takvim -------------------------------------------------------------------------------
    agenda: {
        title: 'Takvim',
        prev: 'Önceki',
        next: 'Sonraki',
        today: 'Bugün',
        newEvent: 'Etkinlik',
        filter: 'Kimin için göster',
        filterAll: 'Herkes',
        emptyDay: 'Bu gün için henüz plan yok',
        emptyDayBody: 'Bir şey eklemek için + simgesine dokun.',
        emptyWeek: 'Bu hafta için henüz plan yok',
        emptyRange: 'Henüz plan yok',
        weekTitle: '{week}. hafta · {range}',
        trash: 'Çöp kutusu',
        trashIntro: 'Silinen etkinlikler 30 gün saklanır.',
        trashEmpty: 'Çöp kutusu boş.',
        restore: 'Geri getir',
        restoreUntil: '{date} tarihine kadar geri getirilebilir',
        restored: '{title} yeniden takvimde',
        restoreExpired: 'Bu etkinlik 30 günden uzun süredir silinmiş, artık geri getirilemez.',
        export: 'Takvimi dışa aktar',
        exportIntro: 'Takvimi telefonun ya da bilgisayarın için .ics dosyası olarak indir.',
        exportHousehold: 'Tüm aile',
        moved: '{title} taşındı: {when}',
        moveFailed: 'Taşınamadı. Etkinlik eski yerinde duruyor.',
        dragHint: 'Taşımak için bir etkinliği sürükle.',
        allDay: 'Tüm gün',
        moreItems: '+{count} daha',
    },
    // ---- Tek bir etkinliğin ayrıntısı -------------------------------------------------------------
    event: {
        when: 'Ne zaman',
        leave: 'Çıkış',
        who: 'Kim',
        where: 'Nerede',
        notes: 'Not',
        repeats: 'Tekrar',
        rides: 'Götürme ve alma',
        dropoff: 'Götürme',
        pickup: 'Alma',
        driverOpen: 'Kim gidecek?',
        driverIs: 'Sürücü: {name}',
        iDrive: 'Ben giderim',
        chooseDriver: 'Kimin gideceğini seç',
        nobody: 'Henüz kimse yok',
        driverSaved: 'Sürücü: {name}',
        driverCleared: 'Sürücü kaldırıldı',
        depart: 'Çıkış {time}',
        travel: '{count} dk yol',
        edit: 'Düzenle',
        cancelOne: 'Bu seferlik iptal et',
        cancelledOne: '{title} bu sefer yapılmayacak',
        cancelled: 'İptal edildi',
        restoreOne: 'Yine de yapılsın',
        restoredOne: '{title} yine de yapılacak',
        resetOne: 'Normal etkinliğe dön',
        resetDone: 'Bu sefer yine serideki gibi',
        resetKeptRide: 'Bu sefer yine serideki gibi. Kimin gideceği, bu sefer için ayarladığın gibi kalıyor.',
        resetKeptReminder: 'Bu sefer yine serideki gibi. Atlanan hatırlatma bu sefer sessiz kalıyor.',
        resetKeptBoth: 'Bu sefer yine serideki gibi. Kimin gideceği ve atlanan hatırlatma, bu sefer için ayarladığın gibi kalıyor.',
        moved: 'Taşındı',
        changed: 'Değişti',
        delete: 'Sil',
        deleted: '{title} silindi',
        deleteTitle: '{title} silinsin mi?',
        deleteBody: '30 gün içinde çöp kutusundan geri getirebilirsin.',
        duplicate: 'Kopyala',
        duplicated: 'Kopya oluşturuldu',
        history: 'Neler değişti?',
        historyEmpty: 'Henüz değişiklik yok.',
        historyItem: '{who} · {when}',
        conflict: 'Başka bir şeyle aynı anda',
        conflictWith: {
            one: '{names}: o saatte ayrıca {title} var',
            other: '{names}: o saatte ayrıca {title} var',
        },
        conflictDrive: '{name} saat {time} için sürücü, ama o saatte ayrıca {title} var',
        lastChanged: 'Son değiştiren: {name}',
        notFound: 'Bu etkinlik artık yok.',
        action: {
            create: 'oluşturuldu',
            update: 'değiştirildi',
            delete: 'silindi',
            restore: 'geri getirildi',
            split: 'buradan itibaren değiştirildi',
            cancel: 'iptal edildi',
            uncancel: 'yine de yapılacak',
            move: 'taşındı',
            override: 'bu seferlik değiştirildi',
            override_clear: 'seriye geri döndü',
            role: 'sürücü değişti',
        },
    },
    // ---- W3 Etkinlik düzenleyici -----------------------------------------------------------------
    editor: {
        ...appEditorG4Tr,
        newTitle: 'Yeni etkinlik',
        editTitle: 'Etkinliği düzenle',
        title: 'Ne',
        titlePlaceholder: 'Örneğin Yüzme dersi',
        titleHint: 'Kısa ve net, örneğin Yüzme dersi',
        templates: 'Hızlı seç',
        picto: 'Simge',
        pictoChoose: 'Bir simge seç',
        pictoChange: 'Başka simge',
        who: 'Kimin için',
        everyone: 'Herkes',
        date: 'Tarih',
        allDay: 'Tüm gün',
        start: 'Başlangıç',
        end: 'Bitiş',
        duration: 'Süre',
        endDate: 'Son gün',
        endBeforeStart: 'Bitiş saati başlangıçtan önce.',
        repeat: 'Tekrarla',
        repeatNone: 'Tekrarlama',
        repeatDaily: 'Her gün',
        repeatWeekly: 'Her hafta',
        repeatBiweekly: 'İki haftada bir',
        repeatMonthly: 'Her ay',
        repeatYearly: 'Her yıl',
        onDays: 'Hangi günler',
        monthlyHow: 'Ayın hangi günü',
        monthlyDay: 'Ayın {day}. günü',
        monthlyLast: 'Ayın son günü',
        monthlyNth: 'Ayın {ordinal} {weekday} günü',
        ordinal: {
            '1': 'ilk',
            '2': 'ikinci',
            '3': 'üçüncü',
            '4': 'dördüncü',
            '-1': 'son',
        },
        parity: 'Hangi haftalar',
        parityAll: 'Tüm haftalar',
        parityEven: 'Çift haftalar',
        parityOdd: 'Tek haftalar',
        ends: 'Bitiş',
        endsNever: 'Hiç bitmesin',
        endsCount: 'Birkaç kez sonra',
        endsUntil: 'Bir tarihte',
        count: 'Kaç kez',
        until: 'Son gün',
        nextDates: 'Sıradaki tarihler',
        rides: 'Götürme ve alma',
        ridesHint: 'Kim götürecek, kim alacak? Henüz bilmiyorsan "Henüz belli değil" seçeneğini seç.',
        dropoff: 'Götürme',
        pickup: 'Alma',
        roleNone: 'Gerek yok',
        roleOpen: 'Henüz açık (kim gidecek?)',
        travel: 'Yol süresi',
        travelNone: 'Yok',
        travelOwn: 'Kendi süren…',
        travelOwnLabel: 'Dakika olarak yol süresi',
        /** 0056: dezelfde reistijd ook ná de afspraak. */
        travelBack: 'Dönüş yolu',
        travelBackHint: 'Aynı yol süresi randevudan sonra da, eve dönüş için.',
        travelAuto: 'Otomatik (yere göre)',
        travelAutoWith: 'Otomatik ({minutes} dk)',
        departureAlert: 'Çıkış hatırlatması',
        departureAlertHint: 'Pano, ne zaman çıkman gerektiğini gösterir.',
        departureNone: 'Hatırlatma yok',
        departureBefore: '{count} dk önce',
        location: 'Nerede',
        locationPlaceholder: 'Örneğin Spor merkezi havuzu',
        notes: 'Not',
        notesPlaceholder: 'Mayo çantası ve havlu unutma',
        category: 'Tür',
        more: 'Daha fazla seçenek: götürme ve alma, yer, not',
        less: 'Daha az seçenek',
        fullScreen: 'Tam ekran',
        smallScreen: 'Küçült',
        create: 'Etkinliği kaydet',
        save: 'Kaydet',
        created: '{title} takvimde',
        saved: 'Etkinlik kaydedildi',
        conflictNotice: {
            one: '{names}: o saatte ayrıca {title} var ({time}).',
            other: '{names}: o saatte ayrıca {title} var ({time}).',
        },
        orphansTitle: 'Tek tek yapılmış değişiklikler var',
        orphansBody: 'Bazı seferleri ayrıca değiştirmiştin, bunlar şimdi kalkıyor. Onlarla ne yapmak istersin?',
        orphansKeep: 'Ayrı etkinlik olarak sakla',
        orphansDelete: 'At',
        onlyThisNoRepeat: 'Tekrarlanan bir etkinliği bu ve sonraki seferler ya da tüm seri için değiştirirsin.',
        titleRequired: 'Ne olduğunu yaz.',
        memberRequired: 'Kimin için olduğunu seç.',
        categories: {
            sport: 'Spor',
            school: 'Okul',
            medisch: 'Doktor ve diş hekimi',
            sociaal: 'Buluşma',
            werk: 'İş',
            verjaardag: 'Doğum günü',
            overig: 'Diğer',
        },
    },
    // ---- Kapsam sorusu (design.scope ekine) ------------------------------------------------------
    scope: {
        thisHint: 'Sadece {date}',
        followingHint: '{date} tarihinden itibaren',
        allHint: 'Tüm seferler, öncekiler de',
        deleteFollowing: 'Bunu ve sonrakileri sil',
        confirm: 'Devam et',
    },
    // ---- W4 Ulaşım -------------------------------------------------------------------------------
    rides: {
        title: 'Ulaşım',
        subtitle: 'Önümüzdeki hafta kim kimi götürüp alıyor.',
        open: 'Henüz sürücü yok',
        arranged: 'Ayarlandı',
        empty: 'Tüm yolculuklar ayarlandı.',
        emptyBody: 'Kimsenin araba aramasına gerek yok.',
        none: 'Bu hafta yolculuk yok.',
        noneBody: 'Bir etkinlikte kimin götürüp alacağını seçersen burada görünür.',
        iDrive: 'Ben giderim',
        choose: 'Seç',
        dropoff: 'Götürme',
        pickup: 'Alma',
        notLinked: 'Hesabın henüz bir aile üyesine bağlı değil. Kimin gideceğini aşağıdan seç.',
    },
    // ---- W5 Görevler -----------------------------------------------------------------------------
    tasks: {
        title: 'Görevler',
        viewToday: 'Bugün',
        viewWeek: 'Hafta',
        viewAll: 'Tümü',
        add: 'Görev',
        addLong: 'Görev ekle',
        newTitle: 'Yeni görev',
        editTitle: 'Görevi düzenle',
        library: 'Ev işi fikirleri',
        libraryIntro: 'Bir iş seç ve kimin için olduğunu belirle. Puanlar yaşa uygun.',
        libraryAdd: 'Ekle',
        libraryFor: 'Kimin için',
        what: 'Ne',
        titlePlaceholder: 'Örneğin Sofrayı kur',
        who: 'Kimin için',
        mode: 'Nasıl',
        modeEach: 'Herkes ayrı',
        modeEachHint: 'Herkes kendisi yapar ve kendi puanını alır.',
        modeTogether: 'Birlikte',
        modeTogetherHint: 'Birlikte yaparsınız; herkes için tek bir işaret.',
        modeFirst: 'İlk yapan',
        modeFirstHint: 'İlk yapan puanları alır.',
        repeat: 'Ne sıklıkla',
        repeatOnce: 'Bir kez',
        repeatDaily: 'Her gün',
        repeatWeekdays: 'Hafta içi',
        repeatWeekly: 'Her hafta',
        repeatMonthly: 'Her ay',
        onDays: 'Hangi günler',
        monthDay: 'Ayın günü',
        monthLast: 'Son gün',
        startDate: 'Başlangıç',
        date: 'Tarih',
        dueDate: 'En geç',
        timeOfDay: 'Günün hangi vakti',
        tod: {
            any: 'Tüm gün',
            morning: 'Sabah',
            afternoon: 'Öğleden sonra',
            evening: 'Akşam',
        },
        dueTime: 'Bitiş saati',
        points: 'Puan',
        pointsHint: 'Kaç yıldız kazandırır? 0 da olur.',
        approval: 'Onay gerekli',
        approvalHint: 'Puanlar sayılmadan önce anne ya da baba görevi onaylar.',
        approvalHintNoPoints: 'Görev tamamlandı sayılmadan önce anne ya da baba kontrol eder.',
        description: 'Açıklama',
        create: 'Görevi kaydet',
        created: '{title} hazır',
        saved: 'Görev kaydedildi',
        deleteTitle: '{title} silinsin mi?',
        deleted: '{title} silindi',
        duplicateTitle: 'Bu görev zaten var',
        duplicateBody: '{names} için zaten bir {title} görevi var. Yine de bir tane daha eklensin mi?',
        addAnyway: 'Yine de ekle',
        emptyTitle: 'Henüz görev yok',
        emptyBody: 'Diş fırçalamak gibi küçük bir şeyle başla.',
        emptyToday: 'Bugün görev yok',
        emptyTodayBody: 'Bugünün görevleri burada görünür.',
        progress: '{done}/{total} bitti',
        completeFor: '{name} için işaretle',
        completed: '{title} işaretlendi',
        revert: 'Yeniden aç',
        reverted: '{title} yeniden açık',
        skip: 'Atla',
        skipped: '{title} atlandı',
        unskip: 'Yine de yap',
        state: {
            open: 'Açık',
            done: 'Bitti',
            pending: 'Onay bekliyor',
            rejected: 'Bir kez daha',
            skipped: 'Atlandı',
            missed: 'Kaçırıldı',
        },
        late: 'Dünden kalan',
        next: 'Bir dahaki sefer: {date}',
        noNext: 'Bir dahaki sefer yok',
        together: 'Birlikte',
        negativeTitle: 'Puan sıfırın altına düşüyor',
        negativeBody: '{names} bu puanları zaten harcadı. Bakiye eksiye düşer.',
        negativeConfirm: 'Yine de geri al',
        perMember: 'Çocuk başına puan',
    },
    // ---- W6 Ödüller ------------------------------------------------------------------------------
    rewards: {
        title: 'Ödüller',
        savings: 'Kumbaralar',
        available: '{count} harcanabilir',
        reserved: '{count} ayrıldı',
        goal: 'Hedef',
        noGoal: 'Henüz birikim hedefi yok',
        setGoal: 'Birikim hedefi',
        goalNone: 'Hedef yok',
        chooseGoal: 'Bir birikim hedefi seç',
        ledger: {
            task_credit: 'Görev',
            task_reversal: 'Görev geri alındı',
            reward_debit: 'Ödül',
            reward_refund: 'Ödül iadesi',
            manual_adjustment: 'Ebeveyn değiştirdi',
            bonus: 'Bonus',
            cleaning_credit: 'Temizlik',
            cleaning_reversal: 'Temizlik geri alındı',
            // Golf 7 (0048): neutraal (blijft staan na wissen).
            learning_credit: 'İyi öğrendi',
            learning_reversal: 'İyi öğrendi geri alındı',
        },
        goalMissing: {
            one: '{count} puan kaldı',
            other: '{count} puan kaldı',
        },
        goalReached: 'Yeterince birikti',
        goalSaved: 'Birikim hedefi kaydedildi',
        catalogue: 'Biriktirilecek ödüller',
        add: 'Ödül',
        addLong: 'Ödül ekle',
        newTitle: 'Yeni ödül',
        editTitle: 'Ödülü düzenle',
        name: 'Ne',
        namePlaceholder: 'Örneğin Birlikte dondurma yemek',
        cost: 'Kaç yıldız?',
        costHint: 'Ödül bu kadar yıldız tutar (1 ile 9999 arası).',
        costInvalid: '1 ile 9999 arasında bir sayı seç.',
        forWhom: 'Kimin için',
        forAll: 'Puanı olan herkes',
        limit: 'Ne sıklıkla',
        limitNone: 'İstediğin kadar',
        limitDay: 'Günde {count} kez',
        limitWeek: 'Haftada {count} kez',
        limitMonth: 'Ayda {count} kez',
        stock: 'Stok',
        stockNone: 'Sınırsız',
        stockLeft: '{count} tane kaldı',
        created: '{name} eklendi',
        saved: 'Ödül kaydedildi',
        archive: 'Kaldır',
        archiveTitle: '{name} kaldırılsın mı?',
        archiveBody: 'Çocuklar artık onu görmez. Önceki istekler saklanır.',
        archived: '{name} kaldırıldı',
        requests: 'İstekler',
        requestsEmpty: 'Bekleyen istek yok.',
        give: 'Ver',
        given: '{name} verildi: {member}',
        decline: 'Reddet',
        declined: 'İstek reddedildi; puanlar geri verildi',
        adjust: 'Puanı değiştir',
        adjustTitle: '{name} için puanı değiştir',
        adjustAmount: 'Ne kadar',
        adjustAmountHint: 'Düşmek için eksi kullan, örneğin -5.',
        adjustReason: 'Neden',
        adjustReasonPlaceholder: 'Örneğin Bahçede ekstra yardım',
        adjustInvalid: '-999 ile 999 arasında bir sayı seç (0 olmaz).',
        adjustReasonRequired: 'Kısaca nedenini yaz.',
        adjusted: '{name} için bakiye şimdi {count}',
        negativeTitle: 'Bakiye eksiye düşüyor',
        negativeBody: 'Bu durumda {name} sıfırın altına düşer. Emin misin?',
        negativeConfirm: 'Evet, değiştir',
        history: 'Son puanlar',
        historyEmpty: 'Henüz puan kazanılmadı.',
        pointsOff: 'Puanlar kapalı',
        export: 'Dışa aktar (CSV)',
    },
    // ---- W7 Onaylar ------------------------------------------------------------------------------
    approvals: {
        title: 'Onaylar',
        open: 'Açık',
        handled: 'Tamamlanan',
        approve: 'Onayla',
        approved: '{title} onaylandı',
        reject: 'Reddet',
        rejectTitle: '{title} reddedilsin mi?',
        rejectNote: 'Daha ne yapılması gerekiyor?',
        rejectNotePlaceholder: 'Örneğin Tabaklar daha masaya konmadı',
        rejected: '{title} geri gönderildi: {name}',
        asks: '{name} istiyor',
        doneAt: 'saat {time} bitti',
        doneAgo: '{ago} bitti',
        give: 'Ver',
        decline: 'Reddet',
        notices: 'Bilmekte fayda var',
        emptyTitle: 'Her şey tamam',
        emptyBody: 'Onaylanacak bir şey yok.',
        handledEmpty: 'Tamamladıkların burada görünecek.',
        state: {
            fulfilled: 'Verildi',
            declined: 'Reddedildi',
            cancelled: 'Geri çekildi',
            expired: 'Süresi doldu',
            pending: 'Açık',
        },
        together: '{names} ile birlikte',
    },
    // ---- W8 Aile ---------------------------------------------------------------------------------
    members: {
        title: 'Aile',
        intro: 'Panoda görünen herkes. Renk ve yüz her yerde tekrar görünür.',
        add: 'Aile üyesi',
        addLong: 'Aile üyesi ekle',
        newTitle: 'Yeni aile üyesi',
        editTitle: 'Düzenle: {name}',
        // Volgorde van het gezin (2026-10-01).
        orderHint: 'Sırayı oklarla belirlersiniz. Bu sıra her yerde geçerli: uygulamada ve panoda.',
        moveUp: '{name} öne al',
        moveDown: '{name} geriye al',
        orderNow: '{name} şimdi {count} kişiden {position}. sırada.',
        orderStale: 'Bu arada ailede bir şey değişti. Liste yeniden yüklendi.',
        name: 'Ad',
        namePlaceholder: 'Örneğin Elif',
        // 0057 (oprichter 1 okt): initialen achter de afspraak.
        initials: 'Baş harfler',
        initialsHint: 'Bir ile üç harf. Takvimde etkinliğin arkasında görünür, örneğin Futbol · A.',
        initialsInvalid: 'Bir ile üç harf girin.',
        kind: 'Kim',
        kindAdult: 'Ebeveyn',
        kindChild: 'Çocuk',
        kindHelper: 'Bakıcı ya da yardımcı',
        age: 'Yaş',
        ageNone: 'Bilmiyorum',
        ageBands: {
            '0-5': '6 yaşından küçük',
            '6-9': '6–9 yaş',
            '10-12': '10–12 yaş',
            '13-15': '13–15 yaş',
            '16+': '16 yaş ve üstü',
        },
        face: 'Yüz',
        faceNone: 'İlk harf',
        preview: 'Böyle görünecek',
        saved: '{name} kaydedildi',
        created: '{name} artık aileden biri',
        you: 'Sen',
        points: 'Puan biriktiriyor',
        inviteTitle: 'Eşini davet et',
        inviteBody: 'Birlikte planlamak daha kolay. Partnerini ekle, sonra e-postayla davet et.',
    },
    // ---- W9 Tabletler ----------------------------------------------------------------------------
    devices: {
        ...appDevicesG4Tr,
        title: 'Tabletler',
        intro: 'Aile panosunun çalıştığı tabletler.',
        add: 'Tablet bağla',
        online: 'Çevrimiçi',
        seen: 'Son görülme {ago}',
        never: 'Hiç görülmedi',
        version: 'Sürüm {version}',
        room: 'Oda',
        rename: 'Yeniden adlandır',
        renameTitle: 'Tableti yeniden adlandır',
        revoke: 'Bağlantıyı kes',
        revokeTitle: 'Bu tabletin bağlantısı kesilsin mi?',
        revokeBody: '{name} ardından yine bir bağlantı kodu gösterir. Onu daha sonra yeniden bağlayabilirsin.',
        revoked: '{name} bağlantısı kesildi',
        saved: 'Tablet kaydedildi',
        statusRevoked: 'Bağlantı kesildi',
        statusSuspect: 'Kontrol et',
        emptyTitle: 'Tableti bağla',
        emptyBody: 'Tablette aile panosunu aç ve kodu buraya yaz.',
    },
    // ---- W10 Ayarlar -----------------------------------------------------------------------------
    settings: {
        title: 'Ayarlar',
        household: 'Aile',
        householdName: 'Ad',
        timezone: 'Saat dilimi',
        wizard: 'Aileyi kur',
        security: 'Güvenlik',
        securityBody: 'Güvenilir ağlar, tarayıcılar ve oturumlar.',
        export: 'Takvimi dışa aktar',
        exportBody: 'Takvimi tüm aile için ya da kişi başına .ics dosyası olarak indir.',
        exportAll: 'Tüm aile',
        data: 'Verileri indir',
        dataBody: 'Verilerinin bir kopyası dosya olarak (JSON), Ailemize uygun olanlar bölümündeki seçimler de dahil. Önce şifrenle onaylarsın.',
        dataMine: 'Benim verilerim',
        dataAll: 'Tüm aile',
        dataStarted: 'Dosya indirilenler klasöründe.',
        about: 'Hakkında',
        version: 'Sürüm {version}',
        open: 'Aç',
    },
    // ---- W11 Kurulum -----------------------------------------------------------------------------
    wizard: {
        step: 'Adım {n} / {total}',
        step1Title: 'Hoş geldiniz',
        step1Body: 'Haftayı birlikte, zahmetsizce görün. Önce ailenle başlayalım.',
        householdName: 'Ailenin adı',
        householdPlaceholder: 'Yılmaz Ailesi',
        yourName: 'Panodaki adın',
        yourNameHint: 'Örneğin Baba ya da Ayşe',
        step2Title: 'Ailede kimler var?',
        step2Body: 'Herkese bir renk ver. Bir çocuk bir hayvan da seçebilir.',
        addMember: 'Birini daha ekle',
        memberAdded: '{name} eklendi',
        step3Title: 'İlk görevler',
        step3Body: 'Birkaç düzenli ev işi seç. Her şeyi sonra değiştirebilirsin.',
        step3For: 'Çocuklar için',
        step3Added: {
            one: '{count} görev eklendi',
            other: '{count} görev eklendi',
        },
        step3NoKids: 'Görev vermek için önce bir çocuk ekle.',
        step4Title: 'Tableti bağla',
        step4Body: 'Oturma odasındaki tablette aile panosunu aç ve kodu yaz.',
        pairNow: 'Tablet bağla',
        finish: 'Bitti',
        done: 'Ailen hazır',
    },
    // ---- Hata ve boş durumlar --------------------------------------------------------------------
    notFoundTitle: 'Bu sayfa yok',
    notFoundBody: 'Bağlantı eski olabilir. Bugün sayfasına dön.',
    toToday: 'Bugün sayfasına git',
    crashTitle: 'Eyvah, bir şeyler ters gitti',
    crashBody: 'Bir kez daha dene. Olmuyor mu? Sayfayı yeniden yükle.',
    reload: 'Yeniden yükle',
};
//# sourceMappingURL=app.tr.js.map